import { Grid, Tooltip} from "@mui/material";

export function getStockorderStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'Title',
            value:'',
            error:false,
            errorMessage:'You must enter Title',
            required:true,
            fieldtype:'string'
        },
        partyid:{
            name:'partyid',
            label:'Party Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        partyname:{
            name:'partyname',
            label:'Party Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        orderstatusid:{
            name:'orderstatusid',
            label:'Order Status Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        orderstatusname:{
            name:'orderstatusname',
            label:'Order Status Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        remarks:{
            name:'remarks',
            label:'Remarks',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        partytypeid:{
            name:'partytypeid',
            label:'Party Type Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'Title', width:100 },
        { field: 'partyid', headerName: 'Party Id', width:150 },
        { field: 'partyname', headerName: 'Party Name', width:150 },
        { field: 'orderstatusid', headerName: 'Order Status Id', width:150 },
        { field: 'orderstatusname', headerName: 'Order Status Name', width:150 },
        { field: 'remarks', headerName: 'Remarks', width:150 },
        { field: 'partytypeid', headerName: 'Party Type Id', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['partyid']:{
          ...formValues['partyid'],
          value:data.partyid,
        },['partyname']:{
          ...formValues['partyname'],
          value:data.partyname,
        },['orderstatusid']:{
          ...formValues['orderstatusid'],
          value:data.orderstatusid,
        },['orderstatusname']:{
          ...formValues['orderstatusname'],
          value:data.orderstatusname,
        },['remarks']:{
          ...formValues['remarks'],
          value:data.remarks,
        },['partytypeid']:{
          ...formValues['partytypeid'],
          value:data.partytypeid,
        },
      })
}